import type { FaireProductEntity } from "../../entity_types/product";

export const p_tk38duf6zb: FaireProductEntity = {
  token: "p_tk38duf6zb",
  type: "product",
  name: "Jumbo Halloween Dumplings Sensory Toys",
  brandToken: "b_f1bkinpani",
  brandName: "NYSLIFE",
  imageUrl:
    "https://cdn.faire.com/fastly/2b7c1d70d91c24ca3a685c0aa74af3ea00485485c461be41e54d854fb289422a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95e2004547d093b5bcc7b8ea8c529b4b95907590b7151805f16791cfe1eefc6b.jpeg",
  ],
  priceDollars: 3.95,
  description:
    "1 Order = 3 Counter Displays (Contains 36 Pieces)\n\n1 Dumpling in Every Steamer!\n\n",
  tags: [],
  msrpDollars: 7.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:36.575Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
